module.exports = __webpack_public_path__ + "static/media/Mask_Group_1_d_pattern.726c4730.png";